const lbaODataSelect = angular.module('app.lbaODataSelect', []);

lbaODataSelect.controller('lbaODataSelectCtrl', require('./lbaODataSelectCtrl'));
lbaODataSelect.directive('lbaODataSelect', require('./lbaODataSelectDir'));

export default lbaODataSelect;



// WEBPACK FOOTER //
// ./src/components/lbaODataSelect/index.js